<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="故障标识" prop="code" class="sj">
					<Input v-model="formValidate.code" placeholder="请输入标识"></Input>
				</FormItem>
				<FormItem label="名称" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入名称"></Input>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					id:'',
					name: '',
					code:''
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '标识不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() {//返回上一页
				this.$router.go(-1)
			},
			 handleSubmit (name) {
				 let _this=this
                this.$refs[name].validate((valid) => {
                    if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/fac/fault/type/update',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
                    } else {
                        this.$Message.error('请完善信息后再进行提交!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
			getData(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/fault/type/get',
				    data: {id:_this.formValidate.id},
					_this: _this,
					success: function(data) {
						_this.formValidate=data.macFaultType
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		created(){
			this.formValidate.id=this.$route.query.id
			this.getData()
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/macFaultType/update.vue